var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{class:[
    'section_base section_box',
    {'is-full-height': _vm.isFullHeight},
    {'has-no-padding': _vm.hasNoPadding},
  ]},[(_vm.hasColumns)?_c('div',{staticClass:"columns is-multiline my-0"},[_vm._t("default")],2):[_vm._t("default")]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }